import { createSelector } from '@reduxjs/toolkit'

export const selectSelectedHall = (state: RootState) => state.hall.selectedHall

export const selectSelectedHallWithInfo = createSelector(
  (state: RootState) => state.hall.halls,
  (state: RootState) => state.hall.selectedHall,
  (halls, selectedHallIdx) => halls.find((hall) => hall.id === selectedHallIdx)
)
